import React, { useRef } from "react";
import {
  useDocumentData,
  useCollectionData,
} from "react-firebase-hooks/firestore";
import * as firebase from "firebase/app";
import { useCallback, useState } from "react";
import { useRouteMatch, useHistory, Link } from "react-router-dom";
import Avatar from "react-avatar";

const Chat = (props) => {
  let url = useRouteMatch();

  const db = firebase.firestore();
  const [chatInfo] = useDocumentData(db.doc(`chats/${url.params.id}`));
  const [messages] = useCollectionData(
    db.collection(`chats/${url.params.id}/messages`)
  );

  const [newMessageInput, setNewMessageInput] = useState();
  const inputRef = useRef();

  // let history = useHistory();

  // if (chatInfo) {
  //   let isMember = false;
  //   chatInfo.users.forEach((user) => {
  //     if (user.id === props.userId) {
  //       isMember = true;
  //     }
  //   });

  //   if (!isMember) {
  //     history.push("/projets/tfe/app");
  //   }
  // }

  const newMessage = useCallback(
    (e) => {
      e.preventDefault();

      let date = new Date();

      let date_day = date.getDate();
      if (date_day < 10) {
        date_day = "0" + date_day;
      }
      let date_month = date.getMonth() + 1;
      if (date_month < 10) {
        date_month = "0" + date_month;
      }
      let date_year = date.getFullYear();
      let date_hour = date.getHours();
      if (date_hour < 10) {
        date_hour = "0" + date_hour;
      }
      let date_minute = date.getMinutes();
      if (date_minute < 10) {
        date_minute = "0" + date_minute;
      }

      let stringDate =
        date_day +
        "/" +
        date_month +
        "/" +
        date_year +
        " - " +
        date_hour +
        ":" +
        date_minute;

      let messageId = Date.now();

      inputRef.current.value = "";

      db.doc(`chats/${url.params.id}/messages/${messageId}`).set({
        text: newMessageInput,
        user_pseudo: props.userName,
        user_id: props.userId,
        date: stringDate,
        id: messageId,
      });

      db.doc(`chats/${url.params.id}`).update({
        last_message: newMessageInput,
        date: messageId,
      });
    },
    [newMessageInput, props.userName, db, url, props.userId]
  );

  const [memberListToggle, setMemberListToggle] = useState();

  const memberListTrigger = useCallback(() => {
    let oldstate = memberListToggle;
    setMemberListToggle(!oldstate);
  }, [memberListToggle]);

  return (
    <section className="chat">
      <div className="chat__header">
        <div className="chatName">
          {chatInfo && (
            <div className="chatName__imgGame">
              <img
                src={require(`../../../../assets/img/${chatInfo.vignette}`)}
                alt="Jeu"
              />
            </div>
          )}

          {chatInfo
            ? chatInfo.chatTitle
            : "Désoler, ce chat n'existe pas, cela peut-être dû à une erreur d'url"}
        </div>
        <button onClick={() => memberListTrigger()} className="chat__btnList">
          <span className="chat__btnListSpan">Membres</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            className="svg-inline--fa fa-user-friends fa-w-20"
            data-icon="user-friends"
            data-prefix="fas"
            viewBox="0 0 640 512"
          >
            <path
              fill="currentColor"
              d="M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"
            ></path>
          </svg>
        </button>
      </div>
      {chatInfo && (
        <div
          className={`chat__main ${
            memberListToggle ? "chat__main--open" : ""
          } `}
        >
          <div className="messages">
            <div className="messages__block">
              <ul className="messages__list">
                {messages &&
                  messages.map((message, key) => (
                    <li key={key} className="messages__el">
                      <Avatar
                        className="messages__avatar"
                        name={message.user_pseudo}
                        size="3rem"
                        round="100%"
                        bsRole="toggle"
                      />
                      <div>
                        <div className="messages__infos">
                          <Link
                            to={`/app/profil/${message.user_id}`}
                            title="Voir le profil"
                          >
                            {message.user_pseudo}
                          </Link>
                          <span className="messages__date">
                            {message.date}{" "}
                          </span>
                        </div>
                        <div className="messages__content">
                          <p>{message.text}</p>
                        </div>
                      </div>
                    </li>
                  ))}
              </ul>
            </div>
            <form onSubmit={(e) => newMessage(e)} className="messages__form">
              <label>Entrez un message</label>
              <input
                onChange={(e) => setNewMessageInput(e.target.value)}
                type="text"
                placeholder="Envoyer un message"
                ref={inputRef}
              />
              <button type="submit">Envoyer</button>
            </form>
          </div>

          <div className="chatList">
            <h2 className="chatList__title">Membres</h2>
            <ul className="chatList__list">
              {chatInfo.users.map((user, key) => (
                <li key={key} className="chatList__el">
                  <Link
                    to={`/app/profil/${user.id}`}
                    className="chatList__link"
                    title="Voir le profil"
                  >
                    <Avatar
                      className="chatList__avatar"
                      name={user.pseudo}
                      size="3rem"
                      round="100%"
                      bsRole="toggle"
                    />
                    <span className="chatList__pseudo">{user.pseudo} </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </section>
  );
};

export default Chat;
